import { useMemo } from 'react'

import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'
import routePath from 'router/routePath'

const contractPaths = {
  confirmContractTerminationPath: routePath.confirmContractTermination,
  confirmContractModificationPath: routePath.confirmContractModification,
  addTenantPath: routePath.addTenantPage,
  documentsPath: routePath.documents,
  frontPagePath: routePath.frontPage,
  paymentInfoPath: routePath.paymentInfo,
  paymentHistoryPath: routePath.paymentHistory,
  terminateContractPath: routePath.terminateContract,
  parkingPath: routePath.parking,
  laundryReservationsPath: routePath.laundryReservations,
  messagesPath: routePath.messages,
  messageThreadPath: routePath.messageThread,
  userInfoPath: routePath.userInfo,
  defectNoticePath: routePath.defectNotice,
  defectNoticeEditPath: routePath.defectNoticeEdit,
  bulletinPath: routePath.bulletin,
  buildingPath: routePath.building,
  bulletinBoardPath: routePath.bulletinBoard,
  bulletinBoardBulletinPath: routePath.bulletinBoardBulletin,
  contactInfoPath: routePath.contactInfo,
  feedbackPath: routePath.feedback,
  feedbackViewPath: routePath.feedbackView,
  questionPath: routePath.question,
  questionViewPath: routePath.questionView,
  saunaReservationsPath: routePath.saunaReservations,
  storagesPath: routePath.storages,
  gymBookingPath: routePath.gymBooking,
  gymReservationsPath: routePath.gymReservations,
  commonAreaReservationsPath: routePath.commonAreaReservations,
}

type ContractPathKey = keyof typeof contractPaths

export const useContractPaths = () => {
  const { currentContractId } = useCurrentContract()

  const paths = useMemo(
    () =>
      Object.fromEntries(
        Object.entries(contractPaths).map(([key, value]) => {
          const contractPathKey = key as ContractPathKey
          const path = value.replace(':contractId', currentContractId)

          return [contractPathKey, path]
        })
      ),
    [currentContractId]
  )

  return paths
}
